import React, { createContext, useContext } from 'react';
import { useLoadScript } from '@react-google-maps/api';

// Define libraries as an array of literal union types
const libraries: ("places" | "marker")[] = ['places', 'marker'];

interface GoogleMapsContextProps {
  isLoaded: boolean;
  loadError?: Error | null;
}

const GoogleMapsContext = createContext<GoogleMapsContextProps>({
  isLoaded: false,
  loadError: null,
});

export const GoogleMapsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
    libraries,
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => useContext(GoogleMapsContext);